/** Contact role tags aligned with ContactsSnapshotCard / ContactManageModal. */

import { customerIsOnTitle } from '../../../../helpers/titleContactStatus';

export type ContactSnapshotTagTone = 'primary' | 'neutral' | 'success';

export type ContactSnapshotTag = {
    key: string;
    label: string;
    tone: ContactSnapshotTagTone;
};

export function getContactSnapshotTags(contact: Record<string, unknown> | null | undefined): ContactSnapshotTag[] {
    if (!contact) return [];

    const tags: ContactSnapshotTag[] = [];
    const isPrimary = !!(contact.IsPrimaryContact || contact.isPrimaryContact);
    if (isPrimary) tags.push({ key: 'primary', label: 'PRIMARY', tone: 'primary' });

    const isSecondary = !!(contact.IsSecondaryContact || contact.isSecondaryContact);
    if (isSecondary) tags.push({ key: 'secondary', label: 'SECONDARY CONTACT', tone: 'neutral' });

    const onUtility = !!(contact.IsUtilityBillOwner || contact.isUtilityBillOwner);
    if (onUtility) tags.push({ key: 'utility', label: 'ON UTILITY', tone: 'neutral' });

    const onTitle = customerIsOnTitle(contact);
    const isHomeowner = onTitle
        ? false
        : !!(contact.IsHomeowner || contact.isHomeowner || contact.IsHomeOwner || contact.isHomeOwner);

    if (isHomeowner) tags.push({ key: 'homeowner', label: 'HOMEOWNER', tone: 'neutral' });
    if (onTitle) tags.push({ key: 'title', label: 'ON TITLE', tone: 'neutral' });

    return tags;
}

/** Tags for utility-holder row when only the utility role should be highlighted. */
export function getUtilityHolderSnapshotTags(contact: Record<string, unknown> | null | undefined): ContactSnapshotTag[] {
    const tags = getContactSnapshotTags(contact);
    const utilityTag = tags.find((t) => t.key === 'utility');
    if (utilityTag) return [utilityTag];
    return [{ key: 'utility', label: 'ON UTILITY', tone: 'neutral' }];
}

export function buildPrimaryContactRoleDetail(contact: Record<string, unknown> | null): string {
    if (!contact) return '—';
    const parts: string[] = [];
    const onContract = !!(contact.AddToContract || contact.addToContract);
    if (onContract) parts.push('signs quotes & agreements');
    return parts.length ? parts.join(' · ') : '';
}
